<template>
    <v-sheet style="background-color:#fff;height:100%">
        <v-toolbar floating elevation="0" style="border-bottom:1px solid #ddd" pb-5>
            <v-toolbar-title>Recibos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items></v-toolbar-items>
        </v-toolbar>

        <v-layout wrap style="height:100%">
            <v-container fill-height v-if="load_feito && invoices.length == 0">
                <v-flex xs12>
                    <v-layout text-center align-center justify-center>
                        <v-flex xs12>
                            <h1 class="display-1 mb-5">
                                
                                <span class="font-weight-bold">Nada</span> por enquanto
                            </h1>
                            <p
                                class="subheading font-weight-regular my-5"
                            >Aqui ficam listados os seus recibos de pagamento.</p>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-container>

            <v-flex xs12 px-3 py-5 v-if="load_feito && invoices.length > 0">
                <v-layout>
                    <v-flex xs12>
                        <v-card elevation="0">
                            
                            <v-data-table
                                :headers="headers"
                                :items="invoices"
                                no-results-text="Sem resultados para essa busca"
                                text
                            >
                            <!-- show-expand-->
                                <template v-slot:item.credit_value="{item}">{{formatarDinheiro(item.credit_value)}}</template>
                                <template v-slot:item.status="{item}">{{item.status}}</template>
                                <template v-slot:item.created_at="{item}">
                                    {{
                                        item.created_at.split(" ")[0].split("-").reverse().join("/")
                                    }}
                                </template>
                                <template v-slot:item.payed_at="{item}">
                                    {{
                                        item.payed_at ? item.payed.split(" ")[0].split("-").reverse().join("/") : ''
                                    }}
                                </template>
                                <template v-slot:item.action="{item}">
                                    <v-btn icon :to="{name:'invoice_view', params:{invoice_id:item.id}}" ><v-icon>view_headline</v-icon></v-btn>
                                </template>
                                
                                <template v-slot:no-data>
                                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-sheet>
</template>

<script>
import PaymentService from "../../../app/Rest/payment";
import { money } from "../../../app/general";

var paymentService = null;
var _money = new money();
var _status = {'not_payed':'NÃO PAGO','payed':'PAGO','cancelled':'CANCELADO','waiting_payment':'AGUARDANDO PAGAMENTO'}

export default {
    data: () => ({
        invoices: [],
        load_feito: false,
        search: "",
        headers: [
            { text: "#ID do Recibo", align: "left", sortable: true, value: "id" },
            { text: "#ID do Crédito", align: "left", sortable: true, value: "credit_id" },
            { text: "Valor", value: "credit_value" },
            { text: "Status", value: "status" },
            { text: "Gerado", value: "created_at" },
            { text: "Data de Pagamento", value: "payment_at" },
            { text: "", value: "action" }            
        ]
    }),
    beforeCreate() {
        this.$vuetify.dataTable = { sortByText: "Ordenar por" };
    },
    mounted() {
        this.$store.commit("loading");
        paymentService = PaymentService.build();
        paymentService
            .get_invoices()
            .then(e => {
                this.invoices = e.items.map(function(e){
                    e.status = _status[e.credit.status];
                    e.credit_value = e.credit.credit_value;
                    e.payed_at = e.credit.payed_at;
                    e.credit_id = e.credit.id;
                    return e;
                });
            })
            .finally(() => {
                this.load_feito = true;
                this.$store.commit("loading", false);
            });
    },
    methods:{
        formatarDinheiro(valor) {
            return _money.formatWithCurrency(valor, 2, ",");
        }
    }
};
</script>
